import type { CategoryTree } from "~~/models/categories";
import type { PlanktonCategoryWithSlugs } from "~~/server/plankton";
import { createCategoryTree } from "~~/models/categories";

export async function useCategories() {
  const nuxtApp = useNuxtApp();
  const { locale } = useI18n();

  const { data } = await useFetch<Array<PlanktonCategoryWithSlugs>>("/api/ecom/categories/navigation-list", {
    key: () => "categories-navigation-list",
    getCachedData: key => nuxtApp.payload.data[key] ?? nuxtApp.static.data[key],
  });

  const language = locale.value.substring(0, 2);
  const tree: CategoryTree = createCategoryTree(data.value, language);

  return { tree: tree, rawData: data };
}
